// extracted by mini-css-extract-plugin
export default {"badge":"EmailStatus-index__badge--jYHMW","noText":"EmailStatus-index__noText--stBpw"};